/* ==========================================================================
   LES FRILEUX — TRACKING
   Couche de données neutre (dataLayer), lisible par GA4, GTM et Meta.
   Elle ne dépose aucun cookie et n'appelle aucun script tiers : c'est votre
   outil de consentement qui décide si un tag lit ou non cette couche.

   Événements e-commerce :
     view_item · view_item_list · select_item · select_variant
     add_to_cart · begin_checkout
   Événement purchase : IMPOSSIBLE depuis le thème. Il se règle côté Shopify
   (Paramètres → Événements clients / Customer Events) une fois la boutique
   ouverte. Voir la checklist d'intégration.

   Interactions suivies : guide des tailles, choix de taille, sticky ATC,
   packs, cross-sell, situations, FAQ, newsletter.
   ========================================================================== */
(function () {
  'use strict';
  if (!window.LF || !window.LF.tracking) return;

  var dl = function (event, payload) {
    window.dataLayer.push(Object.assign({ event: event }, payload || {}));
  };
  var readJSON = function (sel) {
    var el = document.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  };

  /* --------------------------------------------------- vues de page */
  var item = readJSON('[data-lf-view-item]');
  if (item) dl('view_item', { ecommerce: item });

  var list = readJSON('[data-lf-view-list]');
  if (list) dl('view_item_list', { ecommerce: list });

  /* ------------------------------------------------- sélection produit */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-lf-card]');
    if (!card) return;
    dl('select_item', {
      ecommerce: {
        items: [{
          item_id: card.getAttribute('data-product-id'),
          item_name: (card.querySelector('.lf-pcard__title') || {}).textContent,
          index: parseInt(card.getAttribute('data-index'), 10) || 1
        }]
      }
    });
  });

  document.addEventListener('lf:variant:change', function (e) {
    var v = e.detail.variant;
    dl('select_variant', {
      ecommerce: {
        currency: window.LF.currency,
        value: v.price / 100,
        items: [{
          item_id: v.sku || String(v.id),
          item_name: e.detail.product,
          item_variant: v.title,
          price: v.price / 100,
          quantity: 1
        }]
      }
    });
  });

  /* ---------------------------------------------------- ajout au panier */
  document.addEventListener('lf:cart:added', function (e) {
    var items = (e.detail.items || []).map(function (i) {
      return {
        item_id: i.sku || String(i.variant_id || i.id),
        item_name: i.product_title || i.title,
        item_variant: i.variant_title,
        price: (i.final_price != null ? i.final_price : i.price) / 100,
        quantity: i.quantity || 1
      };
    });
    var value = items.reduce(function (sum, i) { return sum + i.price * i.quantity; }, 0);
    dl('add_to_cart', { ecommerce: { currency: window.LF.currency, value: value, items: items } });
  });

  /* ------------------------------------------------------ mise à jour */
  document.addEventListener('lf:cart:updated', function () {
    dl('cart_updated', {});
  });

  /* ------------------------------------------------------- checkout */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[name="checkout"]');
    if (!btn) return;
    fetch(window.LF.routes.cart + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        dl('begin_checkout', {
          ecommerce: {
            currency: cart.currency,
            value: cart.total_price / 100,
            items: cart.items.map(function (i) {
              return {
                item_id: i.sku || String(i.variant_id),
                item_name: i.product_title,
                item_variant: i.variant_title,
                price: i.final_price / 100,
                quantity: i.quantity
              };
            })
          }
        });
      })
      .catch(function () { dl('begin_checkout', {}); });
  }, true);

  /* -------------------------------------------------- interactions UX */
  document.addEventListener('lf:interaction', function (e) {
    dl('interaction', { interaction_name: e.detail.name });
  });
  document.addEventListener('lf:sticky:shown', function () {
    dl('interaction', { interaction_name: 'sticky_atc_visible' });
  });
  document.addEventListener('lf:drawer:open', function (e) {
    dl('interaction', { interaction_name: 'drawer_' + e.detail.name });
  });
})();
